export enum Synced {
    Synced = 'synced',
    Syncing = 'syncing',
    Offline = 'offline',
    Online = 'online',
    Download = 'download'
}